import { Heading } from "components/designV2/heading/heading";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { ColorV2 } from "config/colors";
import styled from "styled-components";
import { FormStyled } from "../registrationContainer/registrationContainer.styled";

export const StyledForm = styled(FormStyled)`
  max-width: 420px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

export const StyledTitle = styled(Heading).attrs({
  color: ColorV2.Blue1,
  level: "h3",
})`
  margin: 0;
  text-align: center;
`;

export const ContinueButton = styled(PrimaryButton)``;
